import { useState } from 'react';

import { TextField, FormControl } from '@mui/material';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import './MaterialDatePicker.css';

const MaterialDatePicker = ({ selectedDate, onChange }) => {
  const nextDayDate = new Date().setDate(new Date().getDate());
  const [value, setValue] = useState(selectedDate || nextDayDate);

  const handleChange = (newValue) => {
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <FormControl fullWidth>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DesktopDatePicker
          label="Choose the date*"
          // inputFormat="MM/dd/yyyy, EEE"
          inputFormat="MMM dd, yyyy"
          views={['year', 'month', 'day']}
          value={value}
          onChange={handleChange}
          renderInput={(params) => <TextField {...params} />}
          disablePast={true}
          disableMaskedInput={true}
        />
      </LocalizationProvider>
    </FormControl>
  );
};

export default MaterialDatePicker;
